<template>
  <span :class="classMap[status]">{{ StatusMap[status] }}</span>
</template>

<script>
import {
  ItemStatusMap,
  ProductStatusMap,
  NoCodeProductStatusMap,
  ProductItemStatusMap,
  DrillWellStatusMap,
  ApplyStatusMap,
  SupplyStatusMap,
  SupplyCategoryMap,
  DeliveryCategoryMap,
  ProductWellPeriodStatusMap,
  StockProductStatusMap,
} from '@/config/global'

export default {
  props: {
    model: '',
    status: 0,
  },
  data() {
    return {
      classMap: {},
    }
  },
  computed: {
    StatusMap() {
      let statusMap = {}
      switch (this.model) {
        case 'item':
          statusMap = ItemStatusMap
          break
        case 'product':
          statusMap = ProductStatusMap
          break
        case 'noCodeProduct':
          statusMap = NoCodeProductStatusMap
          this.classMap = {
            1: 'text-danger',
            2: 'text-success',
            3: 'text-default',
            4: 'text-default',
          }
          break
        case 'stockProduct':
          statusMap = StockProductStatusMap
          this.classMap = {
            1: 'text-success',
            2: 'text-danger',
          }
          break
        case 'productWellPeriod':
          statusMap = ProductWellPeriodStatusMap
          break
        case 'productItem':
          statusMap = ProductItemStatusMap
          break
        case 'drillWell':
          statusMap = DrillWellStatusMap
          break
        case 'supply':
          statusMap = SupplyStatusMap
          this.classMap = {
            1: 'text-default',
            2: 'text-warning',
            3: 'text-success',
            4: 'text-danger',
            6: 'text-danger',
          }
          break
        case 'supplyCategory':
          statusMap = SupplyCategoryMap
          break
        case 'apply':
          statusMap = ApplyStatusMap
          this.classMap = {
            1: 'text-default',
            2: 'text-warning',
            3: 'text-success',
            4: 'text-danger',
          }
          break
        case 'supplyDelivery':
          statusMap = DeliveryCategoryMap
          break
        default:
          statusMap = ItemStatusMap
          break
      }
      return statusMap
    },
  },
}
</script>